/* eslint-disable @typescript-eslint/no-explicit-any */

import { useDispatch } from "react-redux";
import { resetFilters, setFilter, setPagination } from "..";
import { FilterExceptionListState } from "../type";

type filtersKey =
  | "search_sku"
  | "search_ncm"
  | "search"
  | "state"
  | "type"
  | "exception_type"
  | "meta";

export const useFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter = (key: filtersKey, value: any) => {
    dispatch(setFilter({ key, value }));
  };

  const clearFilters = (
    preserve?: Partial<FilterExceptionListState["filters"]>
  ) => {
    dispatch(resetFilters(preserve));
  };
  const updatePagination = (page: number, perPage: number) => {
    dispatch(setPagination({ page, perPage }));
  };

  return { updateFilter, clearFilters, updatePagination };
};
